import { render, staticRenderFns } from "./AdminLegalFee.vue?vue&type=template&id=3485be3d"
import script from "./AdminLegalFee.vue?vue&type=script&lang=js"
export * from "./AdminLegalFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports